import React from 'react';
import Summary from './SummaryV2';
import Tabs from '../../Tabs';
import { TopPanelWrapper, ThresholdHeader } from '../../styled';

interface IProps {
  setView(view: string): string;
  callback?: () => void;
}
// eslint-disable-next-line react/display-name
export default ({ setView, callback }: IProps) => {
  return (
    <TopPanelWrapper>
      <Tabs />
      <ThresholdHeader>Manage Thresholds - Real-Time</ThresholdHeader>
      <Summary setView={setView} callback={callback} />
    </TopPanelWrapper>
  );
};
